import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { MrfiktivByUserAtGen } from "@/services/mrfiktiv/v1/data-contracts";
import { PartnerUserAccessLayer } from "@/store/modules/access-layers/partner-user.access-layer";
import { IPartnerUser } from "./user.entity";

export type IByAtFields = MrfiktivByUserAtGen;

function createByAtClass(prefix: string) {
  @IsFilterable
  class ByAtBase implements IByAtFields {
    @FilterConfig({
      type: FilterTypes.OBJECT_ID,
      displayName: `${prefix}.by`,
      config: {
        itemCallback: () => PartnerUserAccessLayer.entities,
        mapItemToComponent: (item: IPartnerUser) => ({ item }),
        itemValue: "id",
        component: "refs-user"
      }
    })
    by: string;

    @FilterConfig({
      type: FilterTypes.DATE,
      displayName: `${prefix}.at`
    })
    at: string;

    constructor(byAt?: Partial<IByAtFields>) {
      this.by = byAt?.by ?? "";
      this.at = byAt?.at ?? "";
    }
  }

  return Filter.createForClass(ByAtBase);
}

type IByAt = IByAtFields;
const ByAt = createByAtClass("objects.byAt");

type IClosedByAt = IByAtFields;
const ClosedByAt = createByAtClass("objects.closedByAt");

type IIgnoredByAt = IByAtFields;
const IgnoredByAt = createByAtClass("objects.ignoredByAt");

type IArchivedByAt = IByAtFields;
const ArchivedByAt = createByAtClass("objects.archivedByAt");

type IDeletedByAt = IByAtFields;
const DeletedByAt = createByAtClass("objects.deletedByAt");

export {
  ByAt,
  IByAt,
  ClosedByAt,
  IClosedByAt,
  ArchivedByAt,
  IArchivedByAt,
  DeletedByAt,
  IDeletedByAt,
  IgnoredByAt,
  IIgnoredByAt
};
